

import Vue from 'vue'

import {
  LanguageServiceProxy,
  LanguageDto
} from '@/service-proxies/app-v2/language.service-proxies'

const serviceProxy = new LanguageServiceProxy()

export default Vue.extend({
  data() {
    return {
      currentIndex: '',
      dataSource: []
    }
  },
  created() {
    this.loadData()
  },
  watch: {
    currentIndex(val) {
      const current = this.dataSource[val]
      this.$emit('onChoose', current)
      console.log(current)
    }
  },
  methods: {
    async loadData() {
      const res = await serviceProxy.findTenantLanguageList()
      this.dataSource = res
      if(res && res.length) this.choose(0)
    },
    choose(index) {
      this.currentIndex = index
    },
  },
  render() {
    const items = this.dataSource.map((item, index) => {
      return (
        <li
          class={{
            item: true,
            active: this.currentIndex == index
          }}
          onClick={() => this.choose(index)}
        > 
          <div class="name-wrapper">
            <div class="display-name">{item.displayName}</div>
            <div class="name">{item.name}</div>         
          </div>
        </li>
      )
    })
    return (
      <div class="side">
        <ul class="lists">{items}</ul>
      </div>
    )
  }
})
